import Seo from "@/components/Seo";
import { Section, Container, Crumbs } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";
import { SITE } from "@/lib/content";

export default function Terms() {
  return (
    <>
      <Seo title="Terms of engagement" canonical="/terms" description="The terms on which Prox provides advisory services." />
      <section className="pt-16 md:pt-24 pb-12 border-b border-[var(--stone)]" style={{ backgroundColor: "var(--bone)" }}>
        <Container size="md">
          <Crumbs items={[{ label: "Home", to: "/" }, { label: "Terms" }]} />
          <Eyebrow>Legal</Eyebrow>
          <h1 className="t-display2">Terms of engagement</h1>
          <p className="t-sm text-[var(--muted)] mt-4 font-mono">Last updated June 2026</p>
        </Container>
      </section>
      <Section bg="bone">
        <Container size="md" className="!px-0">
          <div className="prose">
            <h2>Prices and GST</h2>
            <p>Every price on this site is in Australian dollars and includes GST. A written scope with a fixed price is provided before any engagement begins, and nothing starts until you approve it.</p>
            <h2>Payment terms</h2>
            <p>Sessions are paid in full before the session. Projects are 50 percent to start and 50 percent on delivery. Retainers are invoiced monthly in advance, with a three-month minimum, then month to month with 30 days notice.</p>
            <h2>Rescheduling</h2>
            <p>You can reschedule free with more than 48 hours notice. Inside 48 hours, the session is treated as delivered.</p>
            <h2>Our guarantee</h2>
            <p>If a piece of work does not help, say so within seven days of delivery and we will either redo it or refund the fee for that piece. This applies to the Margin Check and the First Run Sprint.</p>
            <h2>How we are paid</h2>
            <p>Prox is paid only by you. There is no commission on your factory prices, no markup on supplier quotes, and no referral fee from any factory, freight forwarder or software provider. Every supplier quote is passed to you exactly as the factory sent it, and every supplier contact introduced becomes yours to keep.</p>
            <h2>Scope of advice</h2>
            <p>Prox provides commercial advice on product economics, sourcing and buying. It does not provide statutory accounting, legal, tax or customs advice. Duty, GST and tax positions should be confirmed with a qualified adviser or customs broker. Prox does not issue audits or certify factories.</p>
            <h2>Confidentiality and intellectual property</h2>
            <p>Your business information is kept confidential. Models, plans and documents prepared for you during an engagement are yours to keep and reuse.</p>
            <h2>Contact</h2>
            <p>Prox, {SITE.location}. Email <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.</p>
          </div>
        </Container>
      </Section>
    </>
  );
}
